<template>
  <div class="no-page-card">
    <img
      alt="Başarılı"
      src="https://cdn.dsmcdn.com/seller-center/onboarding/images/no-page.svg"
    >
    <h4 class="title">
      Sistem çalışması nedeniyle şu an işleminizi gerçekleştiremiyoruz.
    </h4>
    <span class="body">
      Lütfen sonra tekrar deneyiniz.
    </span>
    <button
      @click="onClick"
      class="btn btn-mp-primary footer"
    >
      ANA SAYFAYA GİT
    </button>
  </div>
</template>

<script>

export default {
  name: 'NoPage',
  methods: {
    onClick () {
      window.location.href = '/dashboard';
    },
  },
};
</script>

<style scoped lang="scss">
.no-page-card{
  min-height: 351px;
  margin: 0 32px 0;
  padding: 60px 120px;
  border-radius: 6px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  img{
    max-width: 156px;
    padding-top: 60px;
  }

  .title{
    color: #f27a1a;
    line-height: 1;
    font-size: 20px;
    font-weight: 500;
    padding-top: 15px;
    text-align: center;
  }

  .body{
    max-width: 470px;
    font-size: 14px;
    text-align: center;
    color: #273142;
    padding-top: 10px;
  }

  .footer.btn.btn-mp-primary{
    margin-top: 30px;
    max-width: 179px;
    border-radius: 6px;
  }
}
</style>
